import { useQuery } from "@tanstack/react-query";
import { getPageDetails } from "../api/getPageDetails";

type Params = { brandId: string; pageId: string };

export const usePageDetailsQuery = ({ brandId, pageId }: Params) => {
  return useQuery({
    queryKey: ["pageDetails", { pageId, brandId }],
    queryFn: async () => {
      return await getPageDetails({
        pageId,
        brandId,
      });
    },
    staleTime: 0,
  });
};
